export const getHostWithProtocol = () => {
  const domain = process.env.NEXT_PUBLIC_DOMAIN;
  if (!domain) throw new Error("Unable to get domain from env. Is NEXT_PUBLIC_DOMAIN set?");
  const protocol = domain.includes("localhost") ? "http://" : "https://";
  return `${protocol}${domain}`;
};
